import { JagoAxiosInstance } from './JagoAxiosInstance';

export function jagoLoginWithGoogle(params: { token: string }) {
  return JagoAxiosInstance.post('api/v2/support/sso/google', params);
}
